import { useState } from "react";
import { RequestError, useApi } from "../../services";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Paper,
  TextField,
  Typography
} from "@mui/material";
import { HidroDXEditor } from "../edit";
import { ErrorOnDialog } from "./errorModal";
import { BarragemData } from "../../context";
import { CompanyData } from "../../pages";
import { SelectCompany } from "./chooseCompany";

interface AddBarragemProps {
  open: boolean;
  onBarragem?: (barragem: BarragemData) => void;
  onCancel?: () => void;
}

export const AddBarragemModal: React.FC<AddBarragemProps> = ({
  open,
  onCancel,
  onBarragem,
}) => {
  const api = useApi();

  const [empreendimento, setEmpreendimento] = useState<CompanyData>();
  const [error, setError] = useState<RequestError>();
  const [barragem, setBarragem] = useState<Partial<BarragemData>>({
    nome: "",
    descricao: "",
    images: [],
  });

  const handleConfirm = async () => {
    if (!empreendimento) {
      setError({
        error: "Erro ao adicionar barragem",
        message: "Você deve definir o empreendimento responsável pela barragem"
      });
      return;
    }

    const result = await api.barragem.addBarragem(empreendimento.id, barragem.nome ?? "", barragem.descricao);
    if ("error" in result) {
      setError(result);
      return;
    }

    if (onBarragem) onBarragem(result ?? (barragem as BarragemData));
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    setBarragem({
      id: -1,
      nome: "",
      descricao: "",
      images: [],
    });
  };

  return <>
    {error && <ErrorOnDialog
      open={Boolean(error)}
      onClose={() => setError(undefined)}
      {...error}
    />}

    <Dialog
      fullWidth
      open={open}
      maxWidth={"sm"}
      onClose={handleCancel}
    >
      <DialogTitle id="alert-dialog-title">Adicionar Barragem</DialogTitle>

      <DialogContent>
        <Divider />
        <div style={{ height: "1em" }} />

        {/* Textos e upload*/}
        <Box sx={{
          flex: 1,
          gap: "0.5em",
          display: "flex",
          flexDirection: "column",
        }}>
          <TextField
            fullWidth
            label="Nome"
            value={barragem.nome ?? ""}
            onChange={(e) => setBarragem({ ...barragem, nome: e.target.value })}
          />

          <SelectCompany
            initialCompany={empreendimento}
            variant="contained"
            onSelect={(company) => setEmpreendimento(company)}
          />

          {/* Descrição */}
          <Typography>Descrição:</Typography>
          <Paper elevation={0} style={{ textAlign: "justify" }}>
            <HidroDXEditor
              image={false}
              chartMap={false}
              startText={barragem.descricao}
              onChange={(text) => setBarragem({ ...barragem, descricao: text })}
            />
          </Paper>
        </Box>
      </DialogContent>


      <DialogActions>
        <Button variant="contained" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button onClick={handleConfirm} autoFocus>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog >
  </>;
};